// extracted by mini-css-extract-plugin
module.exports = {"suggestions-container":"style_suggestions-container__icnM1","suggestion":"style_suggestion__OzmfE","active":"style_active__upYFB"};